import React, { useEffect, useState } from 'react'
import { Button, Checkbox, CircularProgress, Paper, TextField, Typography } from '@material-ui/core'
import queryString from 'query-string'
import { checkTokenApiCall, resetPasswordApiCall } from '../service/client'

export default function ForgotLandingPage() {
  const { token } = queryString.parse(location.search)

  const [finishedMessage, setFinishedMessage] = useState()
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [tests, setTests] = useState({ minLength: false, oneNum: false })

  useEffect(() => {
    if (token) {
      checkToken()  
    }
  }, [])

  function checkToken() {
    const expired = 'Your password reset is invalid.'
    setLoading(true)
    checkTokenApiCall(token).then(r => {
      setLoading(false)
      if (r.text !== 'good token') {
        setFinishedMessage(expired)
      }
    })
  }

  function submit() {
    const success = 'Password changed successfully, you will be redirected to login.'
    setLoading(true)
    resetPasswordApiCall(token, password).then(r => {
      setLoading(false)
      setFinishedMessage(success)
      setTimeout(() => History.push('/'), 1000)
    })
  }

  function handleSetPassword(value) {
    const setObj = { minLength: false, oneNum: false }
    setObj.minLength = value.length >= 6 ? true : false
    setObj.oneNum = new RegExp('.*[0-9].*').test(value) ? true : false
    setTests(setObj)
    setPassword(value)
  } 
  
  return (
    <Paper style={{ margin: 'auto', marginTop: '10%', width: 400 }}>
      <Typography style={{ padding: 10 }} variant="h4" color="primary">Password Reset</Typography>
      <div style={{ padding: 30, paddingTop: 0, height: 200 }}>
        {finishedMessage ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column', gap: 10 }}>
            <Typography style={{ padding: 10 }} variant="h6" color="primary">{finishedMessage}</Typography>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column', gap: 10 }}>
            <div>New Password</div>
            <TextField value={password} onChange={e => handleSetPassword(e.target.value)} variant='outlined' fullWidth />
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox disabled checked={tests.minLength} />
                <div>Min 6 Characters</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox disabled checked={tests.oneNum} />
                <div>At least one number</div>
              </div>
            </div>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={submit}
              disabled={loading || !tests.minLength || !tests.oneNum}
            >
              {
                loading ? (
                  <CircularProgress color="inherit" />
                ) : 'Reset'
              }
            </Button>
          </div>
        )}
      </div>
    </Paper>
  )
}